import React from 'react';

interface ParallaxBackgroundProps {
  particleCount?: number;
}

/**
 * Decorative particle field — removed.
 *
 * What this used to do, and why none of it survived:
 *
 *  - An unthrottled `mousemove` listener wrote the cursor position into state,
 *    so every pointer move re-rendered the component.
 *  - Each of those renders ran an effect that rebuilt all N particle objects
 *    with `map`, producing a fresh array and fresh object identities, which
 *    reconciled all N nodes and then scheduled another frame — a feedback loop
 *    driven at pointer-event rate.
 *  - On touch devices there is no `mousemove`, so the particles rendered as
 *    N permanently static DOM nodes: pure cost, zero effect.
 *
 * The site is targeting a dense, snappy, low-decoration feel (turbopuffer /
 * Databento as the reference), so this is deleted outright rather than
 * throttled behind `requestAnimationFrame` and a reduced-motion check. A
 * throttled version would still be a per-frame render loop in service of
 * decoration the design direction no longer wants.
 *
 * The component itself is kept as a null-rendering stub rather than having the
 * file deleted: both `LandingPage` and `FAQ` import it, and neither of those
 * files is in this change's scope. It now renders nothing, registers no
 * listeners, and holds no state. The call sites can drop the import whenever
 * those files are next touched.
 */
export const ParallaxBackground: React.FC<ParallaxBackgroundProps> = () => null;
